import { systemEngineEnvironment } from "services/environment/systemEngine";

import { Role, SqlRole } from "./types";

export const getRoles = async (options?: {
  accountName?: string;
  byOwnerUsername?: string;
}): Promise<Role[]> => {
  let where = "";

  if (options?.byOwnerUsername) {
    where = `WHERE er.role_owner = '${options.byOwnerUsername}'`;
  }

  const result = await systemEngineEnvironment.execute<SqlRole>(
    `
SELECT
  er.role_name,
  er.created,
  er.role_owner,

ARRAY_DISTINCT(ARRAY_FILTER( x -> x is not null, ARRAY_AGG(
    ar.grantee
))) as grantees,

ARRAY_DISTINCT(ARRAY_FILTER( x -> x is not null, ARRAY_AGG(
    CASE
      WHEN op.privilege_type IS NOT NULL
    THEN
      [
        op.privilege_type,
        op.object_type,
        op.object_name,
        op.created::text,
        op.object_catalog
      ]
    ELSE
      NULL
    END
))) as privileges

FROM
information_schema.enabled_roles er

LEFT JOIN
information_schema.applicable_roles ar
ON
ar.role_name = er.role_name

LEFT JOIN
  information_schema.object_privileges op
ON
op.grantee = er.role_name

${where}
GROUP BY ALL
`,
    { accountName: options?.accountName }
  );
  const [response] = result;

  return response.rows.map(role => {
    const privileges = role.privileges
      ? role.privileges.filter(Boolean).map(privilege => {
          const [
            privilegeType,
            objectType,
            objectName,
            created,
            objectCatalog,
          ] = privilege;
          return {
            privilegeType,
            objectType,
            objectName,
            created,
            objectCatalog,
          };
        })
      : [];

    return { ...role, privileges, grantees: role.grantees || [] };
  });
};
